/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespComponents_viewer = {|
  +isSkyscraperAdEnabled: ?boolean;
  +isContentModuleEnabled: ?boolean;
  +isBillboardAdEnabled: ?boolean;
  +isThinSearchBrowseEnabled: ?boolean;
  +isMoreWaysToBrowseEnabled: ?boolean;
  +isFollowSearchEnabled: ?boolean;
  +isTradeDoublePointsPromoEnabled?: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespComponents_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isFollowSearchEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NON_MVP_SEARCH_BROWSE\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isSkyscraperAdEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NON_MVP_SEARCH_BROWSE\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isBillboardAdEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NON_MVP_SEARCH_BROWSE\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isThinSearchBrowseEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NON_MVP_SEARCH_BROWSE\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isMoreWaysToBrowseEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NON_MVP_SEARCH_BROWSE\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "isContentModuleEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"NON_MVP_SEARCH_BROWSE\"}"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isTradeDoublePointsPromoEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "enableTradeDoublePointsPromo",
              "type": "String!"
            }
          ],
          "name": "isEnabled",
          "storageKey": "isEnabled{\"key\":\"enableTradeDoublePointsPromo\"}"
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
